<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_ix"></a><a id="author"></a>AUTHOR’S NOTE</h2>
<p class="noindent">When I wrote this novel initially, I felt restricted by the proximity of its story to the environment and events of my recent past decade. This might account for the cryptic tone of the novel’s first version.</p>
<p class="noindenta">Now, years later, in this revised and expanded edition, I have felt free to reinstate all the additional links that bound Jonathan James Whalen to those whom he loved.</p>
<p class="right">J<span class="small">ERZY</span> K<span class="small">OSINSKI</span></p>
<p class="noindent"><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?424891d3